<template>
  <div class="container-withdraw-account" :style="cssVars()">
    <div class="custom-nav-block" :style="`padding-top:${topBarHeight}px; background-color: #f7f6f9;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <span class="tit-left">{{ $t('lang.WithdrawalAccount.k033') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <!-- 图标 -->
      <div class="account-tit">
        <div class="account-img">
          <img :src="icon | imgPath" alt="" />
        </div>
        <span class="line"></span>
        <div class="account-name">{{ withdrawalMethod }}</div>
      </div>

      <!-- 提现国家 -->
      <div class="select">
        <span>{{ $t('lang.BaseModule.k015') }}</span>
        <div class="country">
          <img :src="locaFlag | imgPath" alt="" />
          <div class="account-name">{{ locaCode }}</div>
        </div>
      </div>

      <!-- 哥伦比亚 且是 Transfiya bancaria -->
      <template v-if="locaCode === 'CO'">
        <!-- 姓名 -->
        <div class="select">
          <span>Nombre del Cliente</span>
          <input style="color: #333" type="text" placeholder="Por favor, rellene" v-model.trim="columbiaForm.accountName" />
        </div>
        <!-- 选择（身份类型） -->
        <div class="select">
          <span>Identificación del Cliente</span>
          <van-field v-model="pickerTypeValue1" is-link readonly label="" placeholder="Por favor seleccione" @click="showTypePicker1 = true" />
        </div>
        <!-- 身份类型-填写 -->
        <template v-if="pickerTypeValue1 !== ''">
          <div class="select">
            <input
              style="color: #333"
              type="text"
              :maxlength="pickerTypeValue1 === 'Cédula de Identidad' ? 10 : 6"
              :placeholder="pickerTypeValue1 === 'Cédula de Identidad' ? 'Por favor, introduzca 10 caracteres' : 'Por favor, introduzca 6 caracteres'"
              v-model.trim="columbiaForm.idNumber"
            />
          </div>
        </template>
        <!-- 受益人账号-->
        <div class="select">
          <span>Cuenta beneficiaria</span>
          <input
            style="color: #333"
            type="number"
            placeholder="Ingrese un máximo de 10 dígitos"
            @input="customMaxLen($event, 10, 'columbiaForm.accountId')"
            v-model.trim="columbiaForm.accountId"
          />
        </div>
        <!-- 选择（银行） -->
        <div class="select">
          <span>Nombre del Banco</span>
          <van-field v-model="bankText" is-link readonly label="" :placeholder="$t('lang.WithdrawalAccount.k021')" @click="showBankPicker = true" />
        </div>
      </template>

      <!-- 不是银行卡-->
      <template v-else>
        <div class="select">
          <span>{{ $t('lang.BaseModule.k041') }}</span>
          <input style="color: #333" type="text" :placeholder="$t('lang.WithdrawalAccount.k028')" v-model.trim="accountName" />
        </div>

        <div class="select">
          <span>{{ $t('lang.BaseModule.k001') }}</span>
          <div class="select-account">
            <input type="text" :placeholder="$t('lang.BaseModule.k001')" v-model="accountId" />
          </div>
        </div>
      </template>

      <!-- 保存按钮 -->
      <div class="save-btn" :class="{ 'forbid-submit': this.submitBtnStatus() }" @click="handleSave">
        {{ $t('lang.BaseModule.k051') }}
      </div>
    </div>

    <!-- 选择银行弹窗 -->
    <van-popup v-model="showBankPicker" destroy-on-close round position="bottom">
      <van-picker
        show-toolbar
        :key="locaCode"
        :cancel-button-text="$t('lang.BaseModule.k067')"
        :confirm-button-text="$t('lang.BaseModule.k069')"
        :model-value="pickerValue"
        :columns="bankList"
        @cancel="showBankPicker = false"
        @confirm="handleBankPickerConfirm"
      />
    </van-popup>

    <!-- 哥伦比亚-选择类型弹窗-1 -->
    <van-popup v-model="showTypePicker1" destroy-on-close round position="bottom">
      <van-picker
        show-toolbar
        :key="locaCode"
        :cancel-button-text="$t('lang.BaseModule.k067')"
        :confirm-button-text="$t('lang.BaseModule.k069')"
        :model-value="pickerTypeValue1"
        :columns="columbiaList1"
        @cancel="showTypePicker1 = false"
        @confirm="handleTypePickerConfirm1"
      />
    </van-popup>
  </div>
</template>

<script>
import { apiBindWithdrawAccount, apiEditWithdrawAccount } from '@/api/imee.js'

import _debounce from 'lodash/debounce'
import baseMixin from '../base.mixin.js'

export default {
  mixins: [baseMixin],
  data() {
    return {}
  },
  methods: {
    // 保存
    handleSave: _debounce(
      function () {
        // 去掉空格
        const strAccountId = `${this.accountId}`
        this.accountId = strAccountId.replace(/\s*/g, '')

        let data = {
          accountId: this.accountId,
          accountName: this.accountName,
        }

        // 判断emoji表情
        if (this.hasEmojiCharacter(this.accountName)) {
          this.accountName = ''
          // lang.WithdrawalAccount.k036: "Does not support emoji input"
          this.$client.showToast(this.$t('lang.WithdrawalAccount.k036'))
          return
        }

        // 哥伦比亚
        if (this.withdrawalMethod === 'Transfiya bancaria') {
          if (this.locaCode === 'CO') {
            data = {
              accountId: this.columbiaForm.accountId,
              accountName: this.columbiaForm.accountName,
              bankCode: this.columbiaForm.bankCode,
              idNumber: this.columbiaForm.idNumber,
              idType: this.columbiaForm.idType,
              withdrawalMethod: this.withdrawalMethod,
            }
            const targetLength = `${this.columbiaForm.idNumber}`.length
            if (this.pickerTypeValue1 === 'Cédula de Identidad' && (targetLength < 6 || targetLength > 10)) {
              this.$client.showToast('Cédula de Identidad Por favor ingrese 10 dígitos')
              return
            }
            if (this.pickerTypeValue1 === 'Cédula de Identidad de Extranjero' && (targetLength === 0 || targetLength > 6)) {
              this.$client.showToast('Cédula de Identidad de Extranjero Por favor ingrese 6 dígitos')
              return
            }
            if (`${this.columbiaForm.accountId}`.length < 10) {
              this.$client.showToast('Cuenta Por favor ingrese 10 dígitos')
              return
            }
          }
        }

        // edit
        if (this.cfgId) {
          apiEditWithdrawAccount(data, this.cfgId).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
        // add
        else {
          data.withdrawalMethod = this.withdrawalMethod
          apiBindWithdrawAccount(data).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
      },
      3000,
      {
        leading: true,
        trailing: false,
      }
    ),
    // 保存校验
    submitBtnStatus() {
      if (this.withdrawalMethod === 'Transfiya bancaria') {
        if (this.locaCode === 'CO') {
          if (
            this.columbiaForm.accountId &&
            this.columbiaForm.accountName &&
            this.columbiaForm.bankCode &&
            this.columbiaForm.idNumber &&
            this.columbiaForm.idType
          ) {
            return true
          }
        }
        return false
      }

      return false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../base.scss';
</style>
